import React, { useState } from "react";
import { inject, observer } from "mobx-react";
import MembersTab from "./Members/Members";
import "../../../assets/css/components/Profile/MemberComponent/MemberComponent.css";
import InviteComponent from "./Invite/InviteComponent";
import SuccessModal from "../../../components/common/SuccessModal/SuccessModal";
import ErrorModal from "../../../components/common/ErrorModal/ErrorModal";


const MemberComponent = inject("sharedStore")(
  observer((store) => {
    const {
      sharedStore,
    } = store;
    const [selectedTab] = useState("members")
    const [visibleModal, setVisibleModal] = useState("")
    const [errMsg, setErrorMsg] = useState("")

    
    const closeModal = () => {
      setVisibleModal("")
    };

    const switchModal = (value,errMsg="") => {
      setVisibleModal(value)
      setErrorMsg(errMsg)
    }

    return (
      <div className="member-wrapper app-tab-wrapper">
        <div className="row">
          <div className="col-xs-12 col-sm-8 col-md-8">
            <ul className="nav nav-tabs">
              <li
                className="active"
              >
                <a href="/">Members</a>
              </li>
            </ul>
          </div>
          <div className="col-xs-12 col-sm-4 col-md-4 text-right xs-abs-col">
            {sharedStore.userRole !== 1 ? null : (
              <button
                onClick={() => switchModal(1)}
                className="btn btn-common"
              >
                Invite Member
              </button>
            )}
            <InviteComponent
              switchModal={switchModal}
              modalVisibility={visibleModal === 1 ? true : false}
              closeModalHandler={closeModal}
              modalClass="iz-modal invite-modal"
            />
            <SuccessModal
              modalVisibility={visibleModal === 2 ? true : false}
              closeModalHandler={closeModal}
              messageContent={"Invitation Sent"}
              modalLabel="Success Modal"
              modalClass="iz-modal"
            />
            <ErrorModal
              modalVisibility={visibleModal === 3 ? true : false}
              closeModalHandler={closeModal}
              messageContent={errMsg}
              modalLabel="Error Modal"
              modalClass="iz-modal"
            />
          </div>
        </div>
        <div className="tab-content memberTabContent">
          <div
            className={`tab-pane fade ${selectedTab === "members" ? "in active" : ""
              }`}
          >
            <MembersTab />
          </div>
        </div>
      </div>
    );

  }))

export default MemberComponent;



// WEBPACK FOOTER //
// ./src/components/Profile/MemberComponent/MemberComponent.jsx